import React, { PureComponent } from "react";
import { Input, Button } from "antd";
import find from "lodash/find";
import get from "lodash/get";
import { getGermanWordWithoutArticle } from "helpers";

class Editor extends PureComponent {
  state = {};
  render() {
    const { level, allWords, language, onEdit } = this.props;
    return (
      <div>
        {level.words.map((word, i1) => {
          let foundWord = "";

          if (find(allWords, { id: word.wordID })) {
            foundWord = find(allWords, { id: word.wordID })[
              language
            ].toLowerCase();
            if (language === "de") {
              foundWord = getGermanWordWithoutArticle(foundWord);
            }
          }
          return (
            <div
              style={{ display: "flex", marginTop: 8, alignItems: "center" }}
              key={i1}
            >
              <Input
                ref={node => {
                  this[`input${i1}`] = node;
                }}
                defaultValue={word.wordID}
                style={{ width: 100 }}
                onDoubleClick={() => {
                  const newValue = get(this, [`input${i1}`, "input", "value"]);
                  if (newValue) {
                    const editedLevel = {
                      ...level,
                      words: level.words.map((item, i2) => {
                        if (i1 === i2) {
                          return {
                            ...item,
                            wordID: parseFloat(newValue)
                          };
                        }
                        return item;
                      })
                    };
                    onEdit(editedLevel);
                  }
                }}
              />
              <span style={{ margin: "0 10px", minWidth: 200 }}>
                {foundWord}
              </span>
              {word.correctOrder && (
                <Input
                  defaultValue={word.correctOrder.join(",")}
                  style={{ width: 400 }}
                  onChange={e => {
                    const editedLevel = {
                      ...level,
                      words: level.words.map((item, i2) => {
                        if (i1 === i2) {
                          return {
                            ...item,
                            correctOrder: e.target.value
                              .split(",")
                              .map(c => parseFloat(c))
                              .filter(c => !isNaN(c))
                          };
                        }
                        return item;
                      })
                    };
                    onEdit(editedLevel);
                  }}
                />
              )}
              <Button
                type="danger"
                shape="circle"
                icon="delete"
                onClick={() => {
                  const editedLevel = {
                    ...level,
                    words: level.words.filter((item, i2) => {
                      if (i1 === i2) {
                        return false;
                      }
                      return true;
                    })
                  };
                  onEdit(editedLevel);
                }}
              />
            </div>
          );
        })}
        <Button
          onClick={() => {
            const editedLevel = {
              ...level,
              words: level.words.concat({ wordID: "", correctOrder: [] })
            };
            onEdit(editedLevel);
          }}
          style={{ marginTop: 10 }}
        >
          Add new word
        </Button>
      </div>
    );
  }
}

export default Editor;



// WEBPACK FOOTER //
// ./src/containers/Games/Editor.js